<template>
  <v-app style="height:100%;">
      <div style="height:25%;">
        
      </div>
      <div style="height:75%;">
        <v-icon class="text-h1" color="green">mdi-clipboard-check</v-icon>
        <div class="text-h6 mt-16">เราได้รับคำสั่งซื้อของคุณแล้ว</div>
        <div class="text-subtitle ml-16 mr-16 mt-4" style="color:grey">ref : {{ $route.params.order_id}}</div>
        <div class="text-h7 ml-16 mr-16 mt-2">กรุณาชำระเงินให้เรียบร้อย</div>
        <v-row>
            <v-col cols="5" class="text-right">
                <v-btn outlined style="color:black" rounded color="grey" @click="close">
                <v-icon left>mdi-close</v-icon>ปิด</v-btn>
            </v-col>
            <v-col  cols="7" class="text-left">
                <v-btn style="color:white" rounded color="green" @click="pay">
                <v-icon left>mdi-credit-card-outline</v-icon>ชำระเงินตอนนี้</v-btn>
            </v-col>

        </v-row>
      </div>
  </v-app>
</template>

<style>
html {
    height: 100%;
}
body {
    height: 100%;
}
#app {
    height: 100%;
}
</style>

<script>

import App from '@/models/instance/App'

export default {
  methods : {
    close(){
      window.location.href = App.getAppConfigAddFriendUrl()
    },
    pay(){
      this.$router.push({
        path:"/special/market/pay/" + this.$route.params.order_id
      })
    }
  }
}

</script>